import { Component, OnInit } from '@angular/core';
import { Datossopa } from 'src/app/modelos/datos/datossopa.model';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
///variable de jquey para modal//
declare var $: any;

@Component({
  selector: 'app-editorsopa',
  templateUrl: './editorsopa.component.html',
  styleUrls: ['./editorsopa.component.css']
})
export class EditorsopaComponent implements OnInit {
  public titulo: string = "";
  public descripcion: string = "";
  public operacion: string = "";
  public dificultad: string = "";
  public resultados: Array<number> = [];
  public celdas: Array<number> = [];
  public datosactividad:Datossopa;
  constructor(private servicio: ServicioFirebaseService) { }

  ngOnInit() {
   
  }
  registrarActividad() {
    var cuadricula = document.forms["cuadricula"].getElementsByTagName("input");
    var res = document.forms["resultados"].getElementsByTagName("input");
    for (let item of cuadricula) {
      this.celdas.push(item.value);
    }
    for (let item of res) {
      this.resultados.push(item.value);
    }
    /////////////////////////////////////////////
    this.servicio.afAuth.authState.subscribe(res => {
      if (res) { 
       this.servicio.crearNuevaActividadSopa(res.uid,"sopa",this.titulo,this.descripcion,this.operacion,this.dificultad,this.resultados,this.celdas).then(res=>{
        this.showModal();
       })
      }
    });
  }
  generarnumero(): number {
    return Math.floor(Math.random() * (9 - 1)) + 1;
  }
  showModal():void {
    $("#myModal").modal('show');
  }


}
